import localforage from 'localforage'
import jscookie from 'js-cookie'
import { isEmpty } from 'lodash'

import * as TYPES from './mutations-types'

import { userTokenStorageKey } from '../config'
import * as remote from '../remote'

export const attemptLogin = ({ dispatch },{login, password}) =>
    remote.postLogin({login, password}).then(({token,user})=> {
      dispatch('setToken', token)
      dispatch('setUser', user)
      return user; // keep promise chain
    })

export const logout = ({ dispatch }) => {
  remote.revokeToken()
  // call actions
  return Promise.all([
    dispatch('setToken', null),
    dispatch('setUser', null)
  ])
}

export const setUser = ({ commit }, user) => {
  // Commit the mutations
  commit(TYPES.SET_USER, user)
  return Promise.resolve(user) // keep promise chain
}

export const setToken = ({ commit }, token) => {
  commit(TYPES.SET_TOKEN, token)
  return Promise.resolve(token) // keep promise chain
}

export const checkAuthToken = ({ dispatch, state }) => {
  // If the token exists then all validation has already been done
  if (!isEmpty(state.token)) {
    return Promise.resolve(state.token)
  }

  let cookieToken = jscookie.get(userTokenStorageKey);
  if (cookieToken) return dispatch('setToken', cookieToken);

  /**
   * Token does not exist yet
   * - Recover it from localstorage
   * - Recover also the user, validating the token also
   */
  return localforage.getItem(userTokenStorageKey)
    .then((token) => {
      if (isEmpty(token)) {
        // Token is not saved in localstorage
        return Promise.reject('NO_TOKEN') // Reject promise
      }
      // Put the token in the vuex store
      return dispatch('setToken', token) // keep promise chain
    })

}

export const checkUser = ({ dispatch, state }) => {
  if (!isEmpty(state.user)) {
    return Promise.resolve(state.user)
  }
  return dispatch('checkAuthToken').then(() => dispatch('loadUser'))
}

/**
 * Retrieves updated user information
 * If something goes wrong, the user's token is probably invalid
 */
export const loadUser = ({ dispatch }) => remote.loadUserData()
  .then(user => {
    return dispatch('setUser', user)
  }).catch(() => {
    // Process failure, delete the token
    dispatch('setToken', null)
    return Promise.reject('FAIL_IN_LOAD_USER') // keep promise chain
  })
